import { wrappedGet } from './urlFuncs';
import { GET_DONATIONS_URL } from './../inc/constants';
import { API_URL } from './../inc/config';

export const getdonationsStats = (page, limit, amountSort, dateSort, from_date, to_date) =>{
  return wrappedGet(`${API_URL}${GET_DONATIONS_URL}?page=${page}&limit=${limit}&amount=${amountSort}&date=${dateSort}&fromdate=${from_date}&todate=${to_date}`, 'GET');
}
